import { toDisplayString as _toDisplayString, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { id: "noFunctionsFound" }
const _hoisted_2 = { class: "customHeader" }
const _hoisted_3 = { class: "qbeHeaderContainer" }
const _hoisted_4 = { class: "p-mx-2 kn-truncated" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { key: 2 }
const _hoisted_8 = { key: 3 }
const _hoisted_9 = { key: 4 }
const _hoisted_10 = { key: 5 }
const _hoisted_11 = { class: "p-float-label p-m-4" }
const _hoisted_12 = {
  for: "alias",
  class: "kn-material-input-label"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Button = _resolveComponent("Button")
  const _component_Dialog = _resolveComponent("Dialog")
  const _component_Menu = _resolveComponent("Menu")
  const _directive_tooltip = _resolveDirective("tooltip")

  return (_openBlock(), _createBlock(_Fragment, null, [
    (_ctx.previewData != null)
      ? (_openBlock(), _createBlock(_component_DataTable, {
          key: 0,
          class: "qbe-smart-table",
          first: _ctx.first,
          value: _ctx.previewData.rows,
          scrollable: true,
          scrollHeight: "flex",
          scrollDirection: "both",
          resizableColumns: true,
          reorderableColumns: true,
          rowHover: true,
          columnResizeMode: "expand",
          paginator: true,
          lazy: true,
          rows: 25,
          totalRecords: _ctx.lazyParams.size,
          currentPageReportTemplate: 
            _ctx.$t('common.table.footer.paginated', {
                first: '{first}',
                last: '{last}',
                totalRecords: '{totalRecords}'
            })
        ,
          onPage: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onPage($event))),
          onColumnReorder: _cache[2] || (_cache[2] = ($event: any) => (_ctx.$emit('reordered', $event))),
          onDrop: _cache[3] || (_cache[3] = _withModifiers(($event: any) => (_ctx.onDrop($event)), ["stop"])),
          onDragover: _cache[4] || (_cache[4] = _withModifiers(() => {}, ["prevent"])),
          onDragenter: _cache[5] || (_cache[5] = _withModifiers(() => {}, ["prevent"])),
          stripedRows: "",
          showGridlines: ""
        }, {
          empty: _withCtx(() => [
            _createVNode("div", _hoisted_1, _toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.filteredVisibleFields, (col, index) => {
              return (_openBlock(), _createBlock(_component_Column, {
                class: "kn-truncated",
                hidden: !col.visible,
                field: `column_${index + 1}`,
                key: index,
                style: _ctx.qbeSimpleTableDescriptor.style.column
              }, {
                header: _withCtx(() => [
                  _createVNode("div", _hoisted_2, [
                    _createVNode("div", {
                      class: "qbeCustomTopColor",
                      style: `background-color: ${col.color}`,
                      title: col.entity
                    }, null, 12, ["title"]),
                    _createVNode("div", _hoisted_3, [
                      _withDirectives(_createVNode("i", {
                        class: "fas fa-sort p-ml-2",
                        onClick: ($event: any) => (_ctx.changeOrder(col)),
                        "data-test": 'change-order-' + col.alias
                      }, null, 8, ["onClick", "data-test"]), [
                        [
                          _directive_tooltip,
                          _ctx.$t(`qbe.detailView.smartViewMenu.sorting`),
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      _withDirectives(_createVNode("span", _hoisted_4, [
                        _createTextVNode(_toDisplayString(col.alias), 1)
                      ], 512), [
                        [
                          _directive_tooltip,
                          col.alias,
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      _withDirectives(_createVNode("i", {
                        class: "fas fa-cog p-ml-auto",
                        onClick: ($event: any) => (_ctx.showMenu($event, col))
                      }, null, 8, ["onClick"]), [
                        [
                          _directive_tooltip,
                          _ctx.$t(`qbe.detailView.smartViewMenu.colset`),
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      _withDirectives(_createVNode("i", {
                        class: ["fas fa-filter p-mx-2", { 'qbe-active-filter-icon': _ctx.fieldHasFilters(col) }],
                        onClick: ($event: any) => (_ctx.openFiltersDialog(col))
                      }, null, 10, ["onClick"]), [
                        [
                          _directive_tooltip,
                          _ctx.$t(`qbe.detailView.smartViewMenu.colfil`),
                          void 0,
                          { bottom: true }
                        ]
                      ]),
                      _withDirectives(_createVNode("i", {
                        class: "fas fa-times p-mr-2",
                        onClick: ($event: any) => (_ctx.$emit('removeFieldFromQuery', col.uniqueID)),
                        "data-test": 'delete-column-' + col.alias
                      }, null, 8, ["onClick", "data-test"]), [
                        [
                          _directive_tooltip,
                          _ctx.$t(`qbe.detailView.smartViewMenu.coldel`),
                          void 0,
                          { bottom: true }
                        ]
                      ])
                    ])
                  ])
                ]),
                body: _withCtx((slotProps) => [
                  (typeof slotProps.data[`column_${index + 1}`] === 'number' && slotProps.data[`column_${index + 1}`])
                    ? _withDirectives((_openBlock(), _createBlock("span", _hoisted_5, [
                        _createTextVNode(_toDisplayString(_ctx.getFormattedNumber(col, slotProps.data[`column_${index + 1}`])), 1)
                      ], 512)), [
                        [_directive_tooltip, { value: slotProps.data[`column_${index + 1}`] }]
                      ])
                    : (_ctx.previewData?.metaData?.fields[index + 1]?.type === 'date' && col.type != 'inline.calculated.field')
                      ? (_openBlock(), _createBlock("span", _hoisted_6, _toDisplayString(_ctx.getFormattedDate(slotProps.data[`column_${index + 1}`], _ctx.previewData.metaData.fields[index + 1].metawebDateFormat, 'DD/MM/YYYY')), 1))
                      : (_ctx.previewData?.metaData?.fields[index + 1]?.type === 'date' && col.type == 'inline.calculated.field')
                        ? (_openBlock(), _createBlock("span", _hoisted_7, _toDisplayString(_ctx.getFormattedDate(slotProps.data[`column_${index + 1}`], col.id.format, 'DD/MM/YYYY')), 1))
                        : (_ctx.previewData?.metaData?.fields[index + 1]?.type === 'timestamp' && col.type != 'inline.calculated.field')
                          ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.getFormattedDate(slotProps.data[`column_${index + 1}`], _ctx.previewData.metaData.fields[index + 1].metawebDateFormat, 'DD/MM/YYYY HH:mm:ss.SSS')), 1))
                          : (_ctx.previewData?.metaData?.fields[index + 1]?.type === 'timestamp' && col.type == 'inline.calculated.field')
                            ? (_openBlock(), _createBlock("span", _hoisted_9, _toDisplayString(_ctx.getFormattedDate(slotProps.data[`column_${index + 1}`], col.id.format, 'DD/MM/YYYY HH:mm:ss.SSS')), 1))
                            : _withDirectives((_openBlock(), _createBlock("span", _hoisted_10, [
                                _createTextVNode(_toDisplayString(slotProps.data[`column_${index + 1}`]), 1)
                              ], 512)), [
                                [
                                  _directive_tooltip,
                                  slotProps.data[`column_${index + 1}`],
                                  void 0,
                                  { bottom: true }
                                ]
                              ])
                ]),
                _: 2
              }, 1032, ["hidden", "field", "style"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["first", "value", "totalRecords", "currentPageReportTemplate"]))
      : (_openBlock(), _createBlock("div", {
          key: 1,
          class: "kn-height-full kn-width-full",
          onDrop: _cache[6] || (_cache[6] = ($event: any) => (_ctx.onDrop($event))),
          onDragover: _cache[7] || (_cache[7] = _withModifiers(() => {}, ["prevent"])),
          onDragenter: _cache[8] || (_cache[8] = _withModifiers(() => {}, ["prevent"]))
        }, _toDisplayString(_ctx.$t('common.info.noDataFound')), 33)),
    (_ctx.aliasDialogVisible)
      ? (_openBlock(), _createBlock(_component_Dialog, {
          key: 2,
          class: "qbe-smart-table-alias-dialog",
          visible: _ctx.aliasDialogVisible,
          modal: true,
          closable: false,
          baseZIndex: 1,
          autoZIndex: true
        }, {
          header: _withCtx(() => [
            _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-col-12" }, {
              start: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.alias')), 1)
              ]),
              _: 1
            })
          ]),
          footer: _withCtx(() => [
            _createVNode(_component_Button, {
              class: "kn-button kn-button--secondary",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.aliasDialogVisible = false))
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
              ]),
              _: 1
            }),
            _createVNode(_component_Button, {
              class: "kn-button kn-button--primary",
              onClick: _ctx.changeAlias
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('common.save')), 1)
              ]),
              _: 1
            }, 8, ["onClick"])
          ]),
          default: _withCtx(() => [
            _createVNode("span", _hoisted_11, [
              _createVNode(_component_InputText, {
                id: "alias",
                class: "kn-material-input",
                type: "text",
                maxLength: "50",
                modelValue: _ctx.alias,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_ctx.alias = $event))
              }, null, 8, ["modelValue"]),
              _createVNode("label", _hoisted_12, _toDisplayString(_ctx.$t('common.alias')), 1)
            ])
          ]),
          _: 1
        }, 8, ["visible"]))
      : _createCommentVNode("", true),
    _createVNode(_component_Menu, {
      id: "smartTableMenu",
      ref: "smartTableMenu",
      model: _ctx.menuButtons
    }, null, 8, ["model"])
  ], 64))
}